import type React from "react"
import { useTranslation } from "react-i18next"
import { validateBot } from "../../../../../core/bot-logic"
import { Emotion, type PkmWithCustom } from "../../../../../types"
import type { Pkm } from "../../../../../types/enum/Pokemon"
import { getAvatarSrc } from "../../../../../utils/avatar"
import type { IBot } from "../../../models/bot-v2"

export default function BotAvatar(props: {
  bot: IBot
  onChangeAvatar: (pkm: PkmWithCustom) => void
  onClick: () => void
}) {
  const { t } = useTranslation()

  function handleOnDragOver(e: React.DragEvent) {
    e.stopPropagation()
    e.preventDefault()
  }

  function handleDrop(e: React.DragEvent) {
    e.stopPropagation()
    e.preventDefault()
    const data = e.dataTransfer.getData("text/plain")
    if (data.startsWith("pokemon")) {
      const [type, name] = data.split(",") as [string, Pkm]
      props.onChangeAvatar({
        name,
        emotion: Emotion.NORMAL,
        shiny: false
      })
    }
  }

  const errors = validateBot(props.bot)

  return (
    <div id="bot-info" className="my-box">
      <img
        className="bot-avatar"
        src={getAvatarSrc(props.bot.avatar)}
        onDragOver={handleOnDragOver}
        onDrop={handleDrop}
        onClick={props.onClick}
      />
      <p>
        {props.bot.name} {props.bot.author && "by " + props.bot.author}
      </p>
      <p>ELO: {props.bot.elo}</p>
      <p>
        {errors.length > 0 ? (
          <span
            style={{ color: "var(--color-fg-negative)" }}
            title={errors.join("\n")}
          >
            {t("invalid")}
          </span>
        ) : (
          <span style={{ color: "var(--color-fg-positive)" }}>
            {t("valid")}
          </span>
        )}
      </p>
    </div>
  )
}
